import LanguageValueList from "./LanguageValueList";
// import AdmsIdentifierList from "./AdmsIdentifierList";

function isArrayEmptyOrFalsy(arr) {
    // Check if array contains only one element which is an empty string or falsy value
    return arr.length === 1 && (arr[0] === "" || arr[0] === null || arr[0] === undefined || arr[0].trim() === "");
}

export default class Person {
    // constructor(identifiers = new AdmsIdentifierList(), name = new LanguageValueList(), websites = [], email = []) {
    constructor(name = new LanguageValueList(), email = [], id = "") {
        this.name = name;
        // this.websites = websites;
        this.email = email;
        this.id = id;
    }

    // Getters and Setters
    getName() {
        return this.name;
    }

    setName(name) {
        if (name instanceof LanguageValueList) {
            this.name = name;
        } else {
            throw new Error("Street address must be an instance of LanguageValueList");
        }
    }

    getId() {
        return this.id;
    }

    setId() {
        return this.id;
    }

    /* getWebsites() {
        return this.websites;
    }

    setWebsites(websites) {
        this.websites = websites;
    } */

    getEmails() {
        return this.email;
    }

    setEmails(email) {
        this.email = email;
    }

    isEmpty() {
        return !isArrayEmptyOrFalsy(this.email) && this.name.getValues().length === 0 && this.id === "";
    }

    /* getIdentifiers() {
        return this.identifiers;
    }

    setIdentifiers(identifiers) {
        if (identifiers instanceof AdmsIdentifierList) {
            this.identifiers = identifiers;
        } else {
            throw new Error("Identifiers must be an instance of AdmsIdentifierList");
        }
    } */

    toJSON() {
        return {
            name: this.name.toJSON(),
            // websites: this.websites,
            email: this.email,
            id: this.id,
            // identifiers: this.identifiers.toJSON(), // Convert identifiers to JSON
        };
    }
}
